export default __webpack_public_path__ + "static/media/18 Track 18.6b51e685.mp3";